import { brandPrimary } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';

interface IProps {
	className?: string;
	fillColor?: string;
	size?: number;
}

export const ListOfQuestionsIcon = ({ size = 20, className = '', fillColor = brandPrimary }: IProps) => {
	return (
		<SvgIcon width={size} height={size} fill='none' viewBox='0 0 20 20' className={className}>
			<path
				fill={fillColor}
				fillRule='evenodd'
				d='M2 2v12h4v2l2.667-2H18V2H2Zm2 18v-4H2c-1.103 0-2-.897-2-2V2C0 .897.897 0 2 0h16c1.103 0 2 .897 2 2v12c0 1.103-.897 2-2 2H9.333L4 20Z'
				clipRule='evenodd'
			/>
			<path
				fill={fillColor}
				fillRule='evenodd'
				d='M16 7H8V5h8v2Zm0 4H8V9h8v2ZM6.25 6a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m0 4a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0'
				clipRule='evenodd'
			/>
		</SvgIcon>
	);
};
